var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})
}
var staticRenderFns = []

export { render, staticRenderFns }